import React from 'react';
import {
  mapFileTreeType,
  PermissionNameUnionType,
  useFindAllVenueFilesSuspense,
} from '@api';
import {
  CreateFolderModal,
  FileTree,
  UploadFileModal,
  useFileTreeMethods,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Route } from 'src/routes/_rootLayout/venues/$id.files';

export const VenueFileTree: React.FC = () => {
  const { id: venueId } = Route.useParams();
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const userCanWriteVenueFiles = hasPermission({
    permission: 'VENUES_GENERAL',
    action: 'WRITE',
  });

  const {
    data,
    isFetching: isFetchingTreeItems,
    refetch: refetchFiles,
  } = useFindAllVenueFilesSuspense(venueId, {
    query: {
      select: (response) => mapFileTreeType(response.data),
    },
  });

  const { files, locationId, isInitiallyExpanded } = data;

  const { treeMethods, createFolderModalMethods, uploadFileModalMethods } =
    useFileTreeMethods({
      files,
      locationId,
      isInitiallyExpanded,
      isFetchingTreeItems,
      refetchFiles,
    });

  return (
    <>
      <FileTree {...treeMethods} canWrite={userCanWriteVenueFiles} />
      <CreateFolderModal {...createFolderModalMethods} />
      <UploadFileModal {...uploadFileModalMethods} />
    </>
  );
};
